import { useMutation } from '@apollo/client'

import { AddOrUpdateContactListMutation, AddOrUpdateContactListMutationVariables } from 'gql'
import { ADD_OR_UPDATE_CONTACT_LIST } from 'gql/mutations'

const useEmailSubsribeContactList = () =>
  useMutation<AddOrUpdateContactListMutation, AddOrUpdateContactListMutationVariables>(
    ADD_OR_UPDATE_CONTACT_LIST
  )

export default useEmailSubsribeContactList
